import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';

export const pharmacyStripeBillingFormRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/stripe/billing',
}).lazy(() =>
  import('pages/pharmacy/Stripe/PharmacyStripeBillingFormPage/PharmacyStripeBillingFormPage').then(
    (d) => d.Route
  )
);
